<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>Sites</h1>
        <div class="page__title_buttons">
          <p-button [label]="'Add' | translate" icon="pi pi-plus" (click)="openSiteDetailsModal()" />
        </div>
      </div>
    </div>

    <div class="grid-12 gap-[2rem]">
      <div class="span-12">
        <p-table [value]="sites" [paginator]="true" [rows]="5" [rowsPerPageOptions]="[5, 10, 20]" selectionMode="single">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="code">{{ 'Sites_Table.Code' | translate }} <p-sortIcon field="code" /></th>
              <th pSortableColumn="name">{{ 'Sites_Table.Name' | translate }} <p-sortIcon field="name" /></th>
              <th pSortableColumn="description">
                {{ 'Sites_Table.Description' | translate }}
                <p-sortIcon field="description" />
              </th>
              <th pSortableColumn="isActive">
                {{ 'Sites_Table.Activity' | translate }}
                <p-sortIcon field="isActive" />
              </th>
              <th pSortableColumn="externalSite">
                {{ 'Sites_Table.ExternalSite' | translate }}
                <p-sortIcon field="externalSite" />
              </th>
              <th pSortableColumn="countryId">
                {{ 'Sites_Table.CountryID' | translate }}
                <p-sortIcon field="countryId" />
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-site>
            <tr class="cursor-pointer" (click)="openSiteDetailsModal(site)">
              <td>
                <a>{{ site.code }}</a>
              </td>
              <td>{{ site.name }}</td>
              <td>{{ site.description }}</td>
              <td>{{ site.isActive }}</td>
              <td>{{ site.externalSite }}</td>
              <td>{{ site.countryId }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</main>
